<template>
  <div>
    <!-- HO-Operations Section -->
    <div v-if="currentRoute.includes('ho_operations')">
      <h1 class="subheading text-center mt-8" style="color: #f28a3e">
        HO-Operations
      </h1>
      <div id="ivr" class="ivr">
        <v-container>
          <v-row>
            <v-col
              v-for="(item, index) in operations"
              :key="index"
              cols="12"
              sm="6"
              md="4"
              lg="2"
            >
              <a
                :href="item.href"
                style="text-decoration: none; display: block; width: 100%"
              >
              <div class="tile-container tileCtr">
                <div
                  class="icon-container iconCtr"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <v-icon :style="{ color: item.iconColor, fontSize: '2.5rem' }">
                    {{ item.iconName }}
                  </v-icon>
                </div>
                <div
                  class="title-container titleCtr"
                  :style="{ color: item.iconColor }"
                >
                  {{ item.title }}
                </div>
              </div>
              </a>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>

    <!-- Store Operations Section -->
    <div v-if="currentRoute.includes('store_operations')">
      <h1 class="subheading text-center mt-8" style="color: #f28a3e">
        Store Operation
      </h1>
      <div id="ivr" class="team">
        <v-container>
          <v-row>
            <v-col
              v-for="(item, index) in storeOperation"
              :key="index"
              cols="12"
              sm="6"
              md="4"
              lg="2"
            >
              <a
                :href="item.href"
                style="text-decoration: none; display: block; width: 100%"
              >
              <div class="tile-container tileCtr">
                <div
                  class="icon-container iconCtr"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <v-icon :style="{ color: item.iconColor, fontSize: '2.5rem' }">
                    {{ item.iconName }}
                  </v-icon>
                </div>
                <div
                  class="title-container titleCtr"
                  :style="{ color: item.iconColor }"
                >
                  {{ item.title }}
                </div>
              </div>
              </a>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>

    <!-- MIS Section -->
    <div v-if="currentRoute.includes('mis')">
      <h1 class="subheading text-center mt-8" style="color: #f28a3e">MIS</h1>
      <div id="ivr" class="ivr">
        <v-container>
          <v-row>
            <v-col
              v-for="(item, index) in mis"
              :key="index"
              cols="12"
              sm="6"
              md="4"
              lg="2"
            >
              <a
                :href="item.href"
                style="text-decoration: none; display: block; width: 100%"
              >
              <div class="tile-container tileCtr">
                <div
                  class="icon-container iconCtr"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <v-icon :style="{ color: item.iconColor, fontSize: '2.5rem' }">
                    {{ item.iconName }}
                  </v-icon>
                </div>
                <div
                  class="title-container titleCtr"
                  :style="{ color: item.iconColor }"
                >
                  {{ item.title }}
                </div>
              </div>
              </a>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>

    <!-- B2B Section -->
    <div v-if="currentRoute.includes('b2b')">
      <h1 class="subheading text-center mt-8" style="color: #f28a3e">B2B</h1>
      <div id="ivr" class="ivr">
        <v-container>
          <v-row>
            <v-col
              v-for="(item, index) in b2bItems"
              :key="index"
              cols="12"
              sm="6"
              md="4"
              lg="2"
            >
              <a
                :href="item.href"
                style="text-decoration: none; display: block; width: 100%"
              >
              <div class="tile-container tileCtr">
                <div
                  class="icon-container iconCtr"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <v-icon :style="{ color: item.iconColor, fontSize: '2.5rem' }">
                    {{ item.iconName }}
                  </v-icon>
                </div>
                <div
                  class="title-container titleCtr"
                  :style="{ color: item.iconColor }"
                >
                  {{ item.title }}
                </div>
              </div>
              </a>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentRoute: window.location.href,
      authKey: localStorage.getItem("auth-key"),
      
      operations: [
      {
          href: "https://spencers-ivr.attabot.in/",
          title: "Call-list",
          iconName: "mdi-phone",
          bgColor: "#FFEFD5",
          iconColor: "#F44336",
        },
        {
          href: "https://spencers-ivr.attabot.in/mis",
          title: "MIS",
          iconName: "dashboard",
          bgColor: "#E0F7FA",
          iconColor: "#00796B",
        },
        {
          href: "https://spencers-ivr.attabot.in/staff",
          title: "Staff-List",
          iconName: "person",
          bgColor: "#F3E5F5",
          iconColor: "#8E24AA",
        },{
          href: "https://spencers-ivr.attabot.in/outboundCallerList",
          title: "Outbound Calls",
          iconName: "mdi-phone-classic",
          bgColor: "#F1F8E9",
          iconColor: "#8BC34A",
        },
        {
          href: "https://spencers-ivr.attabot.in/order-recordings",
          title: "Order-Recordings",
          iconName: "mdi-dialpad",
          bgColor: "#EFEBE9",
          iconColor: "#6D4C41",
        },
        {
          href: "https://spencers-ivr.attabot.in/dialedCallList",
          title: "Dial List",
          iconName: "mdi-phone-log",
          bgColor: "#E0F7FA",
          iconColor: "#00796B",
        },
        {
          href: "https://spencers-ivr.attabot.in/contactUs",
          title: "Log Complain",
          iconName: "computer",
          bgColor: "#ECEFF1",
          iconColor: "#546E7A",
        }
      ],
      
      storeOperation: [
        {
          href: "https://spencers-ivr.attabot.in/",
          title: "Call-list",
          iconName: "mdi-phone",
          bgColor: "#FBE9E7",
          iconColor: "#F44336",
        },
        {
          href: "https://spencers-ivr.attabot.in/setting",
          title: "General-Settings",
          iconName: "mdi-wrench",
          bgColor: "#EFEBE9",
          iconColor: "#6D4C41",
        },
        {
          href: "https://spencers-ivr.attabot.in/contactUs",
          title: "Log Complain",
          iconName: "computer",
          bgColor: "#ECEFF1",
          iconColor: "#546E7A",
        }
      ],

      mis: [
        {
          href: "https://spencers-ivr.attabot.in/mis",
          title: "MIS",
          iconName: "mdi-chart-bar",
          bgColor: "#FFEBEE",
          iconColor: "#F44336",
        },
        {
          href: "https://spencers-ivr.attabot.in/order",
          title: "Order Report",
          iconName: "mdi-chart-timeline",
          bgColor: "#E0F7FA",
          iconColor: "#1abc9c",
        }
      ],

      b2bItems: [
      {
          href: "https://spencers-ivr.attabot.in/categoryList",
          title: "B2B",
          iconName: "mdi-domain",
          bgColor: "#E8EAF6",
          iconColor: "#303F9F",
        },
        {
          href: "https://spencers-ivr.attabot.in/b2b-order",
          title: "B2B Order-List",
          iconName: "add_shopping_cart",
          bgColor: "#FBE9E7",
          iconColor: "#E64A19",
        },
      ]
    };
  },
  created() {
    this.currentRoute = window.location.href;
  },
  watch: {
    $route() {
      this.currentRoute = window.location.href;
    }
  }
};
</script>
<style>
html {
  height: 100%;
  scroll-behavior: smooth;
}

.tileCtr {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 8px;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  background-color: #fff;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
  height: 150px;
  min-height: 150px;
}

.tileCtr:hover {
  cursor: pointer;
  transform: translateY(-5px);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 15px;
}

.iconCtr {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 10px;
  transition: transform 0.2s ease;
}

.iconCtr:hover {
  transform: rotate(10deg);
}

.titleCtr {
  margin-top: 10px;
  font-size: 0.9rem;
  font-weight: bold;
  color: #333;
  width: 100%;
  text-align: center;
  white-space: normal;
  line-height: 1.2;
}

.tileCtr:hover .iconCtr {
  transform: scale(1.1);
}
</style>